import { EmailUtils } from '../utils/genericUtils.js'

export const FILE_FLAG_OPTIONS = {
  correctFormat: 'correctFormat',
  incorrectFormat: 'incorrectFormat',
  errorOnItems: 'errorOnItems',
}

const COLLABORATOR_FIELD_ERRORS = {
  email: {
    code: 'email',
    message: 'correo inválido',
  },
  updatedEmail: {
    code: 'updatedEmail',
    message: 'correo inválido',
  },
  role: {
    code: 'role',
    message: 'rol inválido',
  },
  firstName: {
    code: 'firstName',
    message: 'nombre inválido',
  },
  lastName: {
    code: 'lastName',
    message: 'apellido inválido',
  },
}

export const COLLABORATOR_ERRORS = {
  email: COLLABORATOR_FIELD_ERRORS.email.code,
  updatedEmail: COLLABORATOR_FIELD_ERRORS.updatedEmail.code,
  role: COLLABORATOR_FIELD_ERRORS.role.code,
  lastName: COLLABORATOR_FIELD_ERRORS.lastName.code,
  firstName: COLLABORATOR_FIELD_ERRORS.firstName.code,
}

export const MASSIVE_UPLOAD_UPGRADE_RESPONSE = {
  id: 0,
  createdAt: 1696435287503,
  updateExisting: false,
  removeMissing: false,
  created: 0,
  updated: 0,
  removed: 0,
  ignored: 0,
  skipped: 0,
}
export class CollaboratorModel {
  // defaultErrorMessage = 'Colaborador con campos inválidos'

  constructor(
    {
      id,
      lastName = '',
      firstName = '',
      email = '',
      updatedEmail = '',
      webRole = new Role(),
      // errorMessage = undefined,
      status,
      errors,
    } = {
      id,
      lastName: '',
      firstName: '',
      email: '',
      updatedEmail: '',
      webRole,
      // errorMessage: '',
      status: '',
      errors: '',
    }
  ) {
    this.id = id
    this.lastName = lastName
    this.email = email
    this.updatedEmail = updatedEmail
    this.firstName = firstName
    this.webRole = new Role(webRole)
    // this.errorMessage = errorMessage
    this.fieldErrors = new Map()
    // this.errorOnCollaborator = false
    this.status = status
    this.errors = errors
  }

  static fromArray(array = []) {
    if (Array.isArray(array) === false) {
      throw new TypeError(
        `expected Array type, array:${array} is invalid type:${typeof array}`
      )
    }

    return Array.from(array, (e) => new CollaboratorModel(e))
  }
}

class XlsxFrontCollaboratorAdapter {
  defaultErrorMessage = 'Colaborador con campos inválidos'

  constructor(
    {
      id = Math.random(),
      Apellidos = '',
      Nombre = '',
      Correo = '',
      Correo_Nuevo = '',
      Rol = new Role(),
      errorMessage = undefined,
    } = {
      id,
      Apellidos: '',
      Nombre: '',
      Correo: '',
      Correo_Nuevo: '',
      Rol: undefined,
      errorMessage: '',
    }
  ) {
    this.id = id
    this.lastName = Apellidos
    this.email = Correo
    this.updatedEmail = Correo_Nuevo
    this.firstName = Nombre
    this.webRole = Rol
    this.errorMessage = errorMessage
    this.fieldErrors = new Map()
    this.errorOnCollaborator = false
  }

  /**
   *
   * @param {COLLABORATOR_ERRORS} error
   */
  hasError(error) {
    return this.fieldErrors.has(COLLABORATOR_FIELD_ERRORS[error].code)
  }

  /**
   *
   * @param {COLLABORATOR_ERRORS} error
   */
  getError(error) {
    if (this.fieldErrors.has(error) === false) return 'error'

    return this.fieldErrors.get(error)
  }

  hasSomeError() {
    return this.fieldErrors.size != 0
  }

  _clearErrors() {
    this.fieldErrors.clear()
  }

  validateRole(roles = []) {
    if (roles.includes(this.webRole.name) === false) {
      this.fieldErrors.set(
        COLLABORATOR_FIELD_ERRORS.role.code,
        COLLABORATOR_FIELD_ERRORS.role.message
      )
    }
  }

  /**
   *
   * @param {{ string:Array<Role> }}  rolesGroupByName
   */
  setupRoleId(rolesGroupByName = []) {
    if (this.fieldErrors.has(COLLABORATOR_FIELD_ERRORS.role.code)) return

    this.webRole = rolesGroupByName[this.webRole.name]
  }

  validateEmail() {
    const maxCharAllowed = 255
    const exeedCharAllowed = this.email.length > maxCharAllowed
    const isNotString = typeof this.email != 'string'
    const isUndefined = this.email === undefined
    const isEmpty = typeof this.email === 'string' && this.email.trim() === ''
    const isInvalidEmail = EmailUtils.isValidEmail(this.email) === false

    if (
      isNotString ||
      isUndefined ||
      isEmpty ||
      exeedCharAllowed ||
      isInvalidEmail
    ) {
      this.fieldErrors.set(
        COLLABORATOR_FIELD_ERRORS.email.code,
        COLLABORATOR_FIELD_ERRORS.email.message
      )
    }
  }

  validateUpdatedEmail() {
    const maxCharAllowed = 255
    const exeedCharAllowed = this.updatedEmail.length > maxCharAllowed
    const isNotString = typeof this.updatedEmail != 'string'
    const isUndefined = this.updatedEmail === undefined
    const isEmpty =
      typeof this.updatedEmail === 'string' && this.updatedEmail.trim() === ''
    const isInvalidEmail = EmailUtils.isValidEmail(this.updatedEmail) === false
    const hasNoEmail = this.hasError(COLLABORATOR_ERRORS.updatedEmail) === false

    if (hasNoEmail && isEmpty) return

    if (
      isNotString ||
      isUndefined ||
      isEmpty ||
      exeedCharAllowed ||
      isInvalidEmail
    ) {
      this.fieldErrors.set(
        COLLABORATOR_FIELD_ERRORS.updatedEmail.code,
        COLLABORATOR_FIELD_ERRORS.updatedEmail.message
      )
    }
  }

  validateFirstName() {
    const isNotString = typeof this.firstName != 'string'
    const isUndefined = this.firstName === undefined
    const isEmpty =
      typeof this.firstName === 'string' && this.firstName.trim() === ''

    if (isNotString || isUndefined || isEmpty) {
      this.fieldErrors.set(
        COLLABORATOR_FIELD_ERRORS.firstName.code,
        COLLABORATOR_FIELD_ERRORS.firstName.message
      )
    }
  }

  validateLastName() {
    const isNotString = typeof this.lastName != 'string'
    const isUndefined = this.lastName === undefined
    const isEmpty =
      typeof this.lastName === 'string' && this.lastName.trim() === ''

    if (isNotString || isUndefined || isEmpty) {
      this.fieldErrors.set(
        COLLABORATOR_FIELD_ERRORS.lastName.code,
        COLLABORATOR_FIELD_ERRORS.lastName.message
      )
    }
  }

  /**
   *
   * @param {Array<Role>} roles
   * @param {Array<string>} rolesNames
   * @param {{ string:Array<Role> }} rolesGroupByName
   */
  validate(rolesNames = [], rolesGroupByName = []) {
    this._clearErrors()
    this.validateEmail()
    this.validateUpdatedEmail()
    this.validateFirstName()
    this.validateLastName()
    this.validateRole(rolesNames)
    this.setupRoleId(rolesGroupByName)

    this.errorOnCollaborator = this.hasSomeError()

    if (this.errorOnCollaborator) {
      this.errorMessage = this.defaultErrorMessage
    }
  }

  static fromArray(array = []) {
    if (Array.isArray(array) === false) {
      throw new TypeError(
        `expected Array type, array:${array} is invalid type:${typeof array}`
      )
    }

    return Array.from(
      array,
      (e) => new XlsxFrontCollaboratorAdapter({ ...e, Rol: { name: e.Rol } })
    )
  }
}

class Role {
  constructor(
    { hierachy = 0, id = Math.random(), name = '' } = {
      hierachy: 0,
      id: 0,
      name: '',
    }
  ) {
    this.hierachy = hierachy
    this.id = id
    this.name = name
  }

  static fromArray(array = []) {
    if (Array.isArray(array) === false) {
      throw new TypeError(
        `expected Array type, array:${array} is invalid type:${typeof array}`
      )
    }

    return Array.from(array, (e) => new Role(e))
  }
}

export async function loadCollaborator(files, possibleRoles) {
  // console.log(possibleRoles)
  const roles = Role.fromArray(possibleRoles)
  const rolesNames = roles.map((e) => e.name)
  const rolesGroupByName = _groupBy(roles, ({ name }) => name)

  // console.log(roles)

  const { headers, bodyJson } = await new Promise((res, _) => {
    const filerReader = new FileReader()
    filerReader.onload = () => {
      res(parseXlsxToJson(filerReader.result))
    }

    filerReader.readAsArrayBuffer(files[0])
  })

  // console.log(headers)
  // console.log(bodyJson)

  const requiredHeaders = ['Nombre', 'Apellidos', 'Correo', 'Rol']
  const isValidHeaders = validateHeaders(requiredHeaders, headers)

  if (isValidHeaders === false) {
    return {
      collaborators: [],
      fileError: true,
      collaboratorsError: [],
    }
  }

  const collaborators = XlsxFrontCollaboratorAdapter.fromArray(bodyJson)
  const collaboratorsError = []
  // console.log(collaborators)

  for (let i = 0; i < collaborators.length; i++) {
    const collaborator = collaborators[i]
    collaborator.validate(rolesNames, rolesGroupByName)
    if (collaborator.errorOnCollaborator === true) {
      collaboratorsError.push(collaborator)
    }
  }

  return {
    collaborators: collaborators,
    fileError: false,
    collaboratorsError: collaboratorsError,
  }
}

/**
 *
 * @param {Array<XlsxFrontCollaboratorAdapter>} collaborators
 * @param {Array<XlsxFrontCollaboratorAdapter>} errorCollaborators
 * @returns
 */
export function validateParsedCollaborators(
  collaborators,
  errorCollaborators,
  rawPossibleRoles
) {
  const roles = Role.fromArray(rawPossibleRoles)
  const rolesNames = roles.map((e) => e.name)
  const rolesGroupByName = _groupBy(roles, ({ name }) => name)
  // console.log(roles)
  // console.log(errorCollaborators)
  // const tempCollaborators = collaborators.map((e) => structuredClone(e))
  const tempCollaborators = collaborators
  const collaboratorsError = []

  errorCollaborators.forEach((collab) => {
    const indexCollaborator = collaborators.findIndex((e) => e.id === collab.id)
    collaborators[indexCollaborator] = collab
  })

  for (let i = 0; i < collaborators.length; i++) {
    const collaborator = collaborators[i]
    collaborator.validate(rolesNames, rolesGroupByName)
    if (collaborator.errorOnCollaborator === true) {
      collaboratorsError.push(collaborator)
    }
  }

  return {
    collaborators: tempCollaborators,
    fileError: false,
    collaboratorsError: collaboratorsError,
  }
}

function validateHeaders(requiredHeaders = [], headers = []) {
  return requiredHeaders.map((e) => headers.includes(e)).every(Boolean)
}

function parseXlsxToJson(rawData) {
  const XLSX = require('xlsx')
  const data = new Uint8Array(rawData)
  const tempArray = new Array()
  for (let i = 0; i != data.length; ++i) {
    tempArray[i] = String.fromCharCode(data[i])
  }
  const bstr = tempArray.join('')
  // Call XLSX
  const workbook = XLSX.read(bstr, {
    type: 'binary',
  })
  // DO SOMETHING WITH workbook HERE
  const first_sheet_name = workbook.SheetNames[0]
  // Get worksheet
  const worksheet = workbook.Sheets[first_sheet_name]
  //Get "Headers", first row from first sheet
  const cells = XLSX.utils.sheet_to_formulae(worksheet)
  const headerRegex = new RegExp("^([A-Za-z]+)1='(.*)$")
  const headers = cells
    .filter((item) => headerRegex.test(item))
    .map((item) => item.split("='")[1])

  const collaboratorsXlsxMadeJson = XLSX.utils.sheet_to_json(worksheet, {
    raw: true,
  })
  return {
    headers: headers,
    bodyJson: collaboratorsXlsxMadeJson,
  }
}

function _groupBy(array, callback) {
  const tempObj = {}
  for (let i = 0; i < array.length; i++) {
    const el = array[i]
    const val = callback(el)
    tempObj[val] = el
  }

  return tempObj
}
